module.exports = __webpack_public_path__ + "media/images/coupon/task-57226190210173c4995993407b724e9d.svg";